import { defineStore } from 'pinia';

import axios from 'axios'
import { handleError } from '../helpers';
export const useCaseStore = defineStore('CaseStore', {
  state: () => ({
    cases: [],
    // scenarios: [],
    // mainCase: null,
    selectedCaseId: null,
    // selectedCase: null,
    loading: false,
    // selectedCaseId: null
  }),
  getters: {

    // The case the user has navigated to (parent or scenario)
    selectedCase() {
      // console.log('selectedCase:::', this.selectedCaseId, this.cases)
      let foundIndex = this.cases.findIndex((c) => c.Id == this.selectedCaseId);
      if (foundIndex == -1) {
        return null
      }
      return this.cases[foundIndex];
    },
    // All direct scenarios of the selectedCase
    selectedCaseScenarios() {
      if (this.selectedCase?.ParentCaseId) {
        return this.cases.filter((c) => c.ParentCaseId == this.selectedCase?.ParentCaseId);
      }
      return this.cases.filter((c) => c.ParentCaseId == this.selectedCaseId);
    },

    selectedCaseParentCaseId(){
      return this.selectedCase?.ParentCaseId ?? this.selectedCase?.Id
    },

    selectedCaseParentCase(){
      return this.cases.find(c => c.Id === this.selectedCaseParentCaseId)
    },

    isSelectedCaseParentCase(){
      return this.selectedCase?.ParentCaseId == null
    },

    scenariosByParentId: (state) => {
      return (parentId) =>
        state.cases.filter(c => c.ParentCaseId === parentId);
    }



    // // Compute the actual main case: parent if scenario, otherwise itself
    // mainCaseComputed() {
    //   const sel = this.selectedCase;
    //   if (!sel) return null;
    //   return this.cases.find(c => c.Id === (sel.ParentCaseId || sel.Id)) || null;
    // },

    // // All scenarios under the computed mainCase
    // scenariosComputed() {
    //   const root = this.mainCaseComputed;
    //   if (!root) return [];
    //   return this.cases.filter(c => c.ParentCaseId === root.Id);
    // },



  },
  actions: {

    // fetch case by passed in route id 
    async fetchCaseById(caseId) {
      const res = await axios.get(
        `${process.env.VUE_APP_ENDPOINT}/api/cases/${caseId}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }
      );
      return res.data;
    },

    //loads main case by id
    // async fetchMainCase(caseId) {
    //   this.loading = true;
    //   try {
    //     const res = await axios.get(
    //       `${process.env.VUE_APP_ENDPOINT}/api/cases/${caseId}`,
    //       { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }
    //     );
    //     this.mainCase = res.data;
    //     return res.data;
    //   } catch (e) {
    //     handleError(e);
    //     return null;
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    //loads scenarios under main case
    // async fetchCaseScenarios(caseId) {
    //   this.loading = true;
    //   try {
    //     const res = await axios.get(
    //       `${process.env.VUE_APP_ENDPOINT}/api/cases/scenarios/${caseId}`,
    //       { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }
    //     );
    //     // endpoint returns { mainCase, scenarios }
    //     this.scenarios = res.data.scenarios || [];
    //     return this.scenarios;
    //   } catch (e) {
    //     handleError(e);
    //     return [];
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    //loads both main case and scenarios
    async loadCaseTree(caseId) {
      this.selectedCaseId = caseId;
      // 1 request returns both
      const res = await axios.get(
        `${process.env.VUE_APP_ENDPOINT}/api/cases/scenarios/${caseId}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }
      ).catch(err => {
        handleError(err);
        return { data: { mainCase: null, scenarios: [] } };
      });
      this.mainCase = res.data.mainCase;
      this.scenarios = res.data.scenarios;
      return res.data;
    },

    async fetchSelectedCaseScenarios(caseId) {
      await this.loadCases(true);
      this.selectedCaseId = caseId;
      return this.cases.filter((c) => c.ParentCaseId === caseId);
    },

    //loads all cases
    async loadCases(force) {
      // console.log('gets cases')
      if (this.cases.length == 0 || force) {
        this.loading = true;
        await axios
          .get(process.env.VUE_APP_ENDPOINT + '/api/cases', {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('user_token')
            }
          })
          .then((response) => {
            // console.log('Loaded cases: ', response);
            this.cases = response.data.cases;
            this.cases.forEach((c) => {
              c.caseAttributes = JSON.parse(c.caseAttributes);
            })
          })
          .catch(handleError);
      } else {
        // console.log('Cases already loaded, skipping fetch.');
      }
    },

    removeCaseFromStore(caseId) {
      this.cases = this.cases.filter((c) => c.Id != caseId);
    },

    async deleteScenario(caseId) {
      try {
        await axios.delete(
          `${process.env.VUE_APP_ENDPOINT}/api/cases/${caseId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('user_token')}`
            }
          }
        )
        this.removeCaseFromStore(caseId)
        return true
      } catch (err) {
        console.error('Failed to delete scenario:', err)
        return false
      }
    },

    async loadCaseChildren(caseId) {
      let caseProbationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + '/api/caseProbationFactors/byCase/' + caseId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ` + localStorage.getItem('user_token')
          }
        })
        .then((res) => res.data)
        .catch((err) => console.error(err));
      let caseProbationLimitations = await axios
        .get(process.env.VUE_APP_ENDPOINT + '/api/caseProbationLimitationStatus/' + caseId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ` + localStorage.getItem('user_token')
          }
        })
        .then((res) => res.data)
        .catch((err) => console.error(err));
      let charges = await axios
        .get(process.env.VUE_APP_ENDPOINT + '/api/charges/CaseId/' + caseId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ` + localStorage.getItem('user_token')
          }
        })
        .then((res) => res.data)
        .catch((err) => console.error(err));
      let caseCircumstances = await axios
        .get(process.env.VUE_APP_ENDPOINT + '/api/caseCircumstances/byCase/' + caseId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ` + localStorage.getItem('user_token')
          }
        })
        .then((res) => res.data)
        .catch((err) => console.error(err));
      // console.log('CaseProbationFactors', caseProbationFactors);
      // console.log('CaseProbationLimitations', caseProbationLimitations);
      // console.log('Charges', charges);
      // console.log('CaseCircumstances', caseCircumstances);
      return {
        caseProbationFactors,
        caseProbationLimitations,
        charges,
        caseCircumstances
      };
    },
    //   // TO DO: Add CaseJuryInstructions, CaseNegotiationTerms, CustodyCredit
    // },
    async duplicateCaseChildren(childrenObject, caseId) {
      // console.log('Duplicate Case Children:', childrenObject);
      childrenObject.caseProbationFactors.map((cpf) => {
        cpf.CaseId = caseId;
        return cpf;
      });
      childrenObject.caseProbationLimitations.map((cpl) => {
        cpl.CaseId = caseId;
        return cpl;
      });
      childrenObject.charges.map((c) => {
        c.CaseId = caseId;
        return c;
      });
      childrenObject.caseCircumstances.map((cc) => {
        cc.CaseId = caseId;
        return cc;
      });
      // Remove ids from childrenObject
      Object.keys(childrenObject).forEach((key) => {
        childrenObject[key] = childrenObject[key].map((child) => {
          delete child.Id;
          child.CaseId = caseId;
          return child;
        });
      });

      // console.log('Children Object After Removing IDs:', childrenObject);

      for (const key of Object.keys(childrenObject)) {
        for await (const child of childrenObject[key]) {
          try {
            await axios.post(
              `${process.env.VUE_APP_ENDPOINT}/api/${key}`,
              { ...child },
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('user_token')}`
                }
              }
            );
            // console.log(`Duplicated ${key}:`, response.data);
          } catch (error) {
            console.error(`Error duplicating ${key}:`, error);
          }
        }
      }
      return childrenObject;
    },

    async createAllCaseChildren(caseId, childrenObject) {
      // console.log('Creating all related tables...', caseId, childrenObject);

      try {
        const responses = {
          caseProbationLimitations: [],
          caseProbationFactors: [],
          charges: [],
          caseCircumstances: []
        };

        for (const item of childrenObject.caseProbationLimitations) {
          delete item.Id;
          delete item.CaseId;
          const response = await axios.post(
            `${process.env.VUE_APP_ENDPOINT}/api/caseProbationLimitationStatus`,
            { ...item, CaseId: caseId },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('user_token')}`
              }
            }
          );
          responses.caseProbationLimitations.push(response.data);
        }

        for (const item of childrenObject.caseProbationFactors) {
          const response = await axios.post(
            `${process.env.VUE_APP_ENDPOINT}/api/caseProbationFactors`,
            { ...item, CaseId: caseId },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('user_token')}`
              }
            }
          );
          responses.caseProbationFactors.push(response.data);
        }

        // for (const item of childrenObject.charges) {
        //   const response = await axios.post(
        //     `${process.env.VUE_APP_ENDPOINT}/api/charges`,
        //     { ...item, CaseId: caseId },
        //     {
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Authorization: `Bearer ${localStorage.getItem('user_token')}`
        //       }
        //     }
        //   );
        //   responses.charges.push(response.data);
        // }

        for (const item of childrenObject.caseCircumstances) {
          const response = await axios.post(
            `${process.env.VUE_APP_ENDPOINT}/api/caseCircumstances`,
            { ...item, CaseId: caseId },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('user_token')}`
              }
            }
          );
          responses.caseCircumstances.push(response.data);
        }

        // console.log('Finished creating all related tables:', responses);
        return responses;
      } catch (error) {
        console.error('Error creating case children:', error);
        return null;
      }
    },

    async duplicateCase(caseId, scenarioCaseId) {
      const token = localStorage.getItem("user_token");
      const clonedCaseChildren = await axios.post(process.env.VUE_APP_ENDPOINT + '/api/cases/duplicateChildren/' + caseId, {
        scenarioCaseId: scenarioCaseId
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return clonedCaseChildren;
    },

    async deleteCase(caseId) {
      await axios
        .delete(process.env.VUE_APP_ENDPOINT + `/api/cases/${caseId}`, {
          headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
        })
        .then(async (result) => {
          // console.log(result);
          this.removeCaseFromStore(caseId);
          return result;
        })
        .catch(handleError);
    }
  }
});